<div class="section container-fluid">
  <div class="img_wrapper">
    <img src="../../../assets/images/404.gif" alt="" />
  </div>
  <div class="page">Ooops!!! payment page not found</div>
</div>
